import Vue from 'vue'
import Vuetify from 'vuetify'
import VueCurrencyFilter from 'vue-currency-filter'
import VeeValidate from 'vee-validate'
import VModal from "vue-js-modal";

import './stylus/main.styl'

import App from './App'
import { router } from './router'
import store from './store'
import '@/components'

Vue.use(VModal)

Vue.use(Vuetify, {
  theme: {
    primary: '#87c4dc',
    accent: '#7E8080',
    secondary: '#25363d',
    info: '#87c4dc',
    warning: '#EBCC47',
    error: '#DD4C57',
    success: '#7BCC85',
    iotyblue: '#87c4dc',
    iotyblue9: '#bcdeeb',
    iotyblue7: '#CBE5EF',
    iotyblue5: '#DAECF4',
    iotyblue3: '#E9F4F8',
    iotyblue1: '#F8FBFD',
    iotylight: '#FDFEFE',
    iotydark: '#4d707c',
    iotyblack: '#25363d',
    iotygrey: '#7e8080',
    iotygrey9: '#B6B7B7',
    iotygrey7: '#C6C7C7',
    iotygrey5: '#D7D7D7',
    iotygrey3: '#E7E7E7',
    iotygrey1: '#F7F7F7',
    iotylightgrey: '#FCFDFD'
  }
})

Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
})

Vue.use(VeeValidate, {
  mode: 'aggressive'
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  created () {
    this.$store.dispatch('project/findAll')
  }
})



// WEBPACK FOOTER //
// ./src/main.js